import { Injectable } from '@angular/core';
import { LocationService } from '../../services/location/location.service';
import { Observable } from 'rxjs';
import { ClientService } from '../../services/client/client.service';

@Injectable({
  providedIn: 'root'
})
export class ClientBusinessService {

  constructor(
    private clientService: ClientService
  ) { }

  onboardStylist(data): Observable<any> {
    return new Observable((observer) => {
      this.clientService.onboardClient(data).subscribe({
        next: (response) => {
          observer.next(response);
        },
        error: ((error) => {
          observer.error(error);
        })
      });
    })
  }

  updateOnboardClient(data): Observable<any> {
    return new Observable((observer) => {
      this.clientService.updateOnboardClient(data).subscribe({
        next: (response) => {
          
          try {
            observer.next(response)
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  getClientById(id): Observable<any> {
    return new Observable((observer) => {
      this.clientService.getClientById(id).subscribe({
        next: (response) => {
          try {
            observer.next(response);
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  checkEmailFBandDB(email): Observable<any> {
    return new Observable((observer) => {
      this.clientService.checkEmailFBandDB(email).subscribe({
        next: (response) => {
          try {
            observer.next(response);
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }
}
